import * as React from 'react';
import memoizeOne from 'memoize-one';
import devWarning from '../_util/devWarning';
import { changeConfirmLocale } from '../modal/locale';
import LocaleContext from './context';
export const ANT_MARK = 'internalMark';
export default class LocaleProvider extends React.Component {
    constructor(props) {
        super(props);
        changeConfirmLocale(props.locale && props.locale.Modal);
        if (process.env.NODE_ENV !== 'production')
            devWarning(props._ANT_MARK__ === ANT_MARK, 'LocaleProvider', '`LocaleProvider` is deprecated. Please use `locale` with `ConfigProvider` instead: http://u.ant.design/locale');
    }
    componentDidMount() {
        changeConfirmLocale(this.props.locale && this.props.locale.Modal);
    }
    componentDidUpdate(prevProps) {
        var _a, _b, _c, _d, _e, _f;
        const { locale } = this.props;
        if (((_a = prevProps.locale.Modal) === null || _a === void 0 ? void 0 : _a.okText) !== ((_b = locale.Modal) === null || _b === void 0 ? void 0 : _b.okText) ||
            ((_c = prevProps.locale.Modal) === null || _c === void 0 ? void 0 : _c.cancelText) !== ((_d = locale.Modal) === null || _d === void 0 ? void 0 : _d.cancelText) ||
            ((_e = prevProps.locale.Modal) === null || _e === void 0 ? void 0 : _e.justOkText) !== ((_f = locale.Modal) === null || _f === void 0 ? void 0 : _f.justOkText)) {
            changeConfirmLocale(locale && locale.Modal);
        }
    }
    componentWillUnmount() {
        changeConfirmLocale();
    }
    render() {
        const { locale, children } = this.props;
        const contextValue = memoizeOne(localeValue => (Object.assign(Object.assign({}, localeValue), { exist: true })))(locale);
        return <LocaleContext.Provider value={contextValue}>{children}</LocaleContext.Provider>;
    }
}
LocaleProvider.defaultProps = {
    locale: {},
};
